import { plpUpdateType } from 'Models/plpUpdataType'
import plpService from 'Services/plpService'
import { plpType } from 'Models/plpType'
import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ToastContainer } from 'react-toastify'
import Swal from 'sweetalert2'
import './TradersCardDetails.scss'

const TradersCardUpdateForm: FC<{ plp: plpType; onSucess: () => void }> = ({ plp, onSucess }) => {
  const [request, setRequest] = useState(false)

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<plpUpdateType>()

  useEffect(() => {
    // setValue('companyName', plp.companyName)
    // setValue('companyAddress', plp.companyAddress)
    // setValue('companyState', plp.companyState)
    // setValue('companyLGA', plp.companyLGA)
    setValue('dailySalesCapacity', plp.dailySalesCapacity)
    // setValue('bvn', plp.bvn)
    // setValue('cacNumber', plp.cacNumber)
    setValue('stationLeaseDurationMonths', plp?.stationLeaseDurationMonths ?? 0)
    setValue('stationLeaseExpiryDate', plp.stationLeaseExpiryDate ?? '')
    setValue('stationLeaseValuationMajor', plp.stationLeaseValuationMajor ?? 0)
    setValue('leaseAgreementStatus', plp.leaseAgreementStatus ?? '')
    setValue('nmdpraCertificateStatus', plp.nmdpraCertificateStatus ?? '')
  }, [plp, setValue])

  const update = async (data: plpUpdateType) => {
    setRequest(true)

    try {
      await plpService.updatePLP(plp.id, data)
      Swal.fire({
        icon: 'success',
        title: 'Done!',
        text: 'TradersCard application updated successfully',
        timer: 3000,
        showConfirmButton: false,
      })
      onSucess()
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: error?.response?.data?.error || 'Something went wrong',
        timer: 3000,
        showConfirmButton: false,
      })
    } finally {
      setRequest(false)
    }
  }

  return (
    <form onSubmit={handleSubmit(update)} className='edit-plp-form'>
      {/* <div className='form-input mb-3'>
        <label className='form-label'>Company Name</label>
        <input
          type='text'
          className='form-control'
          placeholder='Company Name'
          {...register('companyName', {
            required: 'Company name is required',
          })}
        />
        {errors.companyName && <span className='errors'>{errors.companyName.message}</span>}
      </div>

    
      <div className='form-input mb-3'>
        <label className='form-label'>Company Address</label>
        <input
          type='text'
          className='form-control'
          placeholder='Company Address'
          {...register('companyAddress', {
            required: 'Company address is required',
          })}
        />
        {errors.companyAddress && <span className='errors'>{errors.companyAddress.message}</span>}
      </div>

 
      <div className='form-input mb-3'>
        <label className='form-label'>State</label>
        <input
          type='text'
          className='form-control'
          placeholder='State'
          {...register('companyState', {
            required: 'State is required',
          })}
        />
        {errors.companyState && <span className='errors'>{errors.companyState.message}</span>}
      </div>

     
      <div className='form-input mb-3'>
        <label className='form-label'>LGA</label>
        <input
          type='text'
          className='form-control'
          placeholder='LGA'
          {...register('companyLGA', {
            required: 'LGA is required',
          })}
        />
        {errors.companyLGA && <span className='errors'>{errors.companyLGA.message}</span>}
      </div> */}

      <div className='form-input mb-3'>
        <label className='form-label'>Daily Sales Capacity</label>
        <input
          type='number'
          className='form-control'
          placeholder='Daily Sales Capacity'
          {...register('dailySalesCapacity', {
            required: 'Daily sales capacity is required',
            min: { value: 1, message: 'Must be greater than 0' },
          })}
        />
        {errors.dailySalesCapacity && (
          <span className='errors'>{errors.dailySalesCapacity.message}</span>
        )}
      </div>

      {/* <div className='form-input mb-3'>
        <label className='form-label'>BVN</label>
        <input
          type='text'
          className='form-control'
          placeholder='BVN'
          {...register('bvn', {
            required: 'BVN is required',
            minLength: { value: 11, message: 'BVN must be 11 digits' },
            maxLength: { value: 11, message: 'BVN must be 11 digits' },
          })}
        />
        {errors.bvn && <span className='errors'>{errors.bvn.message}</span>}
      </div> */}

      {/* <div className='form-input mb-3'>
        <label className='form-label'>CAC Number</label>
        <input
          type='text'
          className='form-control'
          placeholder='CAC Number'
          {...register('cacNumber', {
            required: 'CAC number is required',
          })}
        />
        {errors.cacNumber && <span className='errors'>{errors.cacNumber.message}</span>}
      </div> */}

      <div className='form-input mb-3'>
        <label className='form-label'>Lease Duration (Months)</label>
        <input
          type='number'
          className='form-control'
          placeholder='Lease Duration'
          {...register('stationLeaseDurationMonths', {
            required: 'Lease duration is required',
            min: { value: 1, message: 'Minimum is 1 month' },
          })}
        />
        {errors.stationLeaseDurationMonths && (
          <span className='errors'>{errors.stationLeaseDurationMonths.message}</span>
        )}
      </div>

      <div className='form-input mb-3'>
        <label className='form-label'>Lease Expiry Date</label>
        <input
          type='date'
          className='form-control'
          {...register('stationLeaseExpiryDate', {
            required: 'Lease expiry date is required',
          })}
        />
        {errors.stationLeaseExpiryDate && (
          <span className='errors'>{errors.stationLeaseExpiryDate.message}</span>
        )}
      </div>

      <div className='form-input mb-3'>
        <label className='form-label'>Lease Valuation</label>
        <input
          type='number'
          className='form-control'
          placeholder='Lease Valuation'
          {...register('stationLeaseValuationMajor', {
            required: 'Lease valuation is required',
            min: { value: 1, message: 'Must be greater than 0' },
          })}
        />
        {errors.stationLeaseValuationMajor && (
          <span className='errors'>{errors.stationLeaseValuationMajor.message}</span>
        )}
      </div>

      <div className='form-input mb-3'>
        <label className='form-label'>Lease Agreement Status</label>
        <select
          className='form-control'
          {...register('leaseAgreementStatus', {
            required: 'Lease status is required',
          })}
        >
          <option value=''>Select Status</option>
          <option value='active'>Active</option>
          <option value='expired'>Expired</option>
        </select>
        {errors.leaseAgreementStatus && (
          <span className='errors'>{errors.leaseAgreementStatus.message}</span>
        )}
      </div>

      <div className='form-input mb-3'>
        <label className='form-label'>NMDPRA Certificate Status</label>
        <select
          className='form-control'
          {...register('nmdpraCertificateStatus', {
            required: 'NMDPRA status is required',
          })}
        >
          <option value=''>Select Status</option>
          <option value='REGISTERED'>REGISTERED</option>
          <option value='EXPIRED'>EXPIRED</option>
          <option value='ACTIVE'>ACTIVE</option>
        </select>
        {errors.nmdpraCertificateStatus && (
          <span className='errors'>{errors.nmdpraCertificateStatus.message}</span>
        )}
      </div>

      <button className='btn btn-default w-100' disabled={request}>
        Update
        {request && <span className='spinner-border spinner-border-sm ms-2' />}
      </button>

      <ToastContainer />
    </form>
  )
}

export default TradersCardUpdateForm
